<template>
  <div v-if="staffProfile && hasAssignments" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5">
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center gap-2">
        <div class="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
          <i class="pi pi-calendar text-sm"></i>
        </div>
        <h3 class="font-bold text-gray-800 text-sm">Today's Classes</h3>
      </div>
      <span class="text-[10px] text-gray-400 font-medium px-2 py-1 bg-gray-50 rounded-full">
        {{ todayLabel }}
      </span>
    </div>

    <!-- Empty state -->
    <div v-if="!todaySlots.length" class="text-center py-4">
      <i class="pi pi-check-circle text-2xl text-gray-300 mb-2 block"></i>
      <p class="text-xs text-gray-400">No classes scheduled today</p>
    </div>

    <!-- Timetable entries -->
    <div v-else class="space-y-2">
      <div
        v-for="(slot, i) in todaySlots.slice(0, 5)"
        :key="i"
        class="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-gray-50"
      >
        <div class="text-[10px] font-mono text-gray-500 w-16 shrink-0">
          {{ slot.time }}
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-xs font-semibold text-gray-800 truncate">{{ slot.subject }}</p>
          <p class="text-[10px] text-gray-400">{{ slot.classroom }}</p>
        </div>
      </div>
      <p v-if="todaySlots.length > 5" class="text-[10px] text-gray-400 text-center pt-1">
        +{{ todaySlots.length - 5 }} more
      </p>
    </div>

    <!-- Link -->
    <div class="mt-4 pt-3 border-t border-gray-100">
      <router-link
        :to="{ name: 'admin-timetable' }"
        class="flex items-center gap-1.5 text-xs text-primary hover:text-primary-700 font-medium"
      >
        <i class="pi pi-calendar text-[10px]"></i>
        View Full Timetable
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStaffDashboard } from '@/composables/useStaffDashboard';

const { staffProfile, hasAssignments } = useStaffDashboard();

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const todayLabel = computed(() => DAYS[new Date().getDay()]);

interface TimetableSlot {
  time: string
  subject: string
  classroom: string
}

const todaySlots = computed<TimetableSlot[]>(() => 
  // Timetable data is not currently fetched on dashboard — show empty until timetable query is integrated
  [],
);
</script>
